import { Badge } from '../../../components/ui/badge';
import { Button as CarbonButton } from '@carbon/react';
import { Activity, Loader2 } from 'lucide-react';
import GatewayTypeTags from '../../../components/GatewayTypeTags';

/**
 * Compact MQTT connect strip for per-gateway settings (native LilyGoGatewayAdmin / GatewayAdmin).
 * Replaces the full multi-gateway status list when lockGateway is set.
 */
export default function GatewayCompactConnectBar({
  gateway,
  connected,
  isOnline,
  isTesting,
  lastSeen,
  onTest,
  onToggleConnect,
}) {
  if (!gateway) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 p-4 border border-[#e0e0e0] rounded-lg bg-white">
      <div className="min-w-0 space-y-1">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-semibold text-[#161616] truncate">{gateway.name}</span>
          <GatewayTypeTags gateway={gateway} showSource={false} />
          {isOnline ? (
            <Badge variant="default" className="bg-green-500">Online</Badge>
          ) : (
            <Badge variant="secondary">Offline</Badge>
          )}
          {connected && (
            <Badge variant="outline" className="border-[#0f62fe] text-[#0f62fe]">MQTT ready</Badge>
          )}
        </div>
        <div className="text-xs text-[#525252] font-mono">{gateway.mac_address}</div>
        {lastSeen && (
          <div className="text-xs text-[#525252]">
            Last seen: {new Date(lastSeen).toLocaleString()}
          </div>
        )}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <CarbonButton kind="secondary" size="sm" onClick={onTest} disabled={isTesting}>
          {isTesting ? <Loader2 className="h-4 w-4 animate-spin" /> : (
            <>
              <Activity className="h-4 w-4 mr-2" />
              Test
            </>
          )}
        </CarbonButton>
        <CarbonButton
          kind={connected ? 'primary' : 'secondary'}
          size="sm"
          onClick={onToggleConnect}
        >
          {connected ? 'Disconnect' : 'Connect'}
        </CarbonButton>
      </div>
    </div>
  );
}
